import * as React from 'react';
import {Popover} from '../../popover/popover';
import {STATUS_OK} from '../../../redux/modules/video/constants';
import {
  POPOVER_CONTENT,
  POPOVER_CONTENT_QUESTION,
  POPOVER_CONTENT_NEW_QUESTION,
  POPOVER_BUTTON_LABEL,
} from './data';

export interface ISessionQuestionPopoverProps {
  selfStatus: string;
  isQuestionNew: boolean;
  isInterviewer: boolean;
  hadQuestionChanged: boolean;
  ackQuestion?: () => void;
}

export const SessionQuestionPopover: React.StatelessComponent<ISessionQuestionPopoverProps> = ({
  selfStatus,
  isQuestionNew,
  isInterviewer,
  hadQuestionChanged,
  ackQuestion,
}: ISessionQuestionPopoverProps) => (
    <Popover
      visible={selfStatus === STATUS_OK && isInterviewer && hadQuestionChanged}
    >
      <p className={'popover-component-text popover-component-text_white'}>
        {POPOVER_CONTENT}
        {isQuestionNew ? POPOVER_CONTENT_NEW_QUESTION : POPOVER_CONTENT_QUESTION}
      </p>

      <p className={'popover-btn-wrap'}>
        <button className={'btn btn_violet'} onClick={ackQuestion}>
          {POPOVER_BUTTON_LABEL}
        </button>
      </p>
    </Popover>
  );
